import React from 'react'
import { oneOfType, array, object } from 'prop-types'
import { EMPTY_OBJECT } from '../../../utils/constants'
import Icon from '../../ui/icon/Icon'

const MobileList = ({ content, title, mobileListProps = EMPTY_OBJECT }) => {
  const { item, activeFilter, contentClasses, containerClasses, onClick } = mobileListProps
  return <li className='ad-filter__menu-item'>
    <div className='ad-filter__menu-header' onClick={e => onClick(e, item)}>
      <span className={`ad-filter__menu-title ${activeFilter ? 'active' : null}`}>
        {title}
      </span>
      <Icon svg={activeFilter ? 'cancel' : 'downShortArrow'} withoutFill={activeFilter} />
    </div>
    <div className={contentClasses}>
      <div className={containerClasses}>
        <div className='ad-filter__list-buttons'>
          {content}
        </div>
      </div>
    </div>
  </li>
}

MobileList.propTypes = {
  content: oneOfType([object, array]),
  title: object,
  mobileListProps: object
}

export default MobileList